export default function WhyChooseUsSection() {
  const reasons = [
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'All-Cash Offers',
      description: 'We buy apartments with cash, eliminating financing contingencies and delays. Our offers are backed by proof of funds, and we can close as soon as the title company completes their work.'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Title Company Protection',
      description: 'Every transaction is handled through a reputable title company, ensuring proper title searches, lien resolution, and secure fund transfers. Your interests are fully protected throughout the process.'
    },
    {
      icon: 'ri-speed-fill',
      title: 'Fast Closings',
      description: 'Sell my apartments fast is not just a slogan—it\'s our commitment. We can close in 7-14 days once you accept our offer, compared to 6-12 months with traditional apartment sales.'
    },
    {
      icon: 'ri-trophy-fill',
      title: 'Proven Track Record',
      description: 'With 150+ apartment buildings purchased and over $85 million in transactions, we have the experience and resources to handle any size deal. Check our references and verified closings.'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Buy As-Is Condition',
      description: 'No need to make repairs, renovations, or improvements. We buy apartments in any condition—from fully occupied and well-maintained to vacant and needing major work.'
    },
    {
      icon: 'ri-file-list-3-fill',
      title: 'Handle All Paperwork',
      description: 'Our team manages all documentation, from purchase agreements to tenant notifications. We work directly with the title company to ensure every detail is handled professionally.'
    },
    {
      icon: 'ri-group-fill',
      title: 'Tenant Situations Welcome',
      description: 'Whether your apartments are fully occupied, partially vacant, or have problem tenants, we buy them all. We can take over existing leases or work with you on tenant transitions.'
    },
    {
      icon: 'ri-calculator-fill',
      title: 'Fair Market Valuations',
      description: 'Our offers are based on comprehensive market analysis, comparable sales, income potential, and property condition. We provide detailed explanations of how we arrived at our offer price.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Why Choose Us
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Apartment Owners Choose T-Rex Real Estate
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            When you need to sell my apartments fast, you need apartment buyers with experience, integrity, and resources. Here's why property owners throughout El Paso trust us with their multi-family investments.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Ready to Sell Your Apartments?</h3>
          <p className="text-xl text-teal-100 mb-8 max-w-2xl mx-auto">
            Get a fair cash offer today from experienced apartment buyers with a proven track record
          </p>
          <a 
            href="tel://+19152065814"
            className="inline-block px-10 py-5 bg-white text-teal-600 rounded-lg font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814 Now
          </a>
        </div>
      </div>
    </section>
  );
}